import React from "react";
import { useNavigate } from "react-router-dom";
import "./EmailHeader.scss";

const EmailHeader: React.FC = () => {
  const navigate = useNavigate();

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  return (
    <div className="email-header">
      <button 
        className="email-header__back-btn" 
        onClick={handleBackButtonClick}
        aria-label="Go back"
      >
        <i className="bi bi-arrow-left"></i>
      </button>
      <h1 className="email-header__title">Email</h1>
    </div>
  );
};

export default EmailHeader;